import React, { useEffect, useRef, useState } from "react";
import { ReactSortable } from "react-sortablejs";
import BuilderRightSideBar from "../../../../Layouts/BuilderRightSideBar";
import BuilderTabs from "../../../../Layouts/BuilderTabs";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import { mapArrayToObject } from "../../../../commonFunctions/arrayFunc";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import SingleJobPopup from "../../../../components/BuilderComponents/JobConfigration/SingleJobPopup";
import ColumnPreFilters from "../../../../components/BuilderComponents/PreFilters/ColumnPreFilters";
import OwnerPreFilters from "../../../../components/BuilderComponents/PreFilters/OwnerPreFilters";
import { NewPrefilter } from "../../../../components/BuilderComponents/PreFilters/PreFilter";
import PreFilterDefaultSort from "../../../../components/BuilderComponents/PreFilters/PreFilterDefaultSort";
import {
  getPrefilterOperatorName,
  getPrefilterOperatorValue
} from "../../../../components/BuilderComponents/PreFilters/operatorData";
import IconPreview from "../../../../components/BuilderComponents/Preview/IconPreview";
import TableTreeModal from "../../../../components/BuilderComponents/TableTreeModal";
import EditButtonConfig from "../../../../components/EditComponents/EditButtonConfig";
import Button from "../../../../components/FormComponents/Button";
import Input from "../../../../components/FormComponents/Input";
import Label from "../../../../components/FormComponents/Label";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import Toggle from "../../../../components/FormComponents/Toggle";
import EditPositionFields from "../../../../components/PositionEditElements/EditPositionFields";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import { useAxiosContext } from "../../../../context/AxiosContext";
import { useTableContext } from "../../../../context/TableContext";
import { useTreeContext } from "../../../../context/TreeDataContext";
import useClickOutside from "../../../../hooks/useClickOutside";
import { elementConfig } from "../../../../utils/Config/DefaultConfig/elementConfig";
import { getDefaultConfig } from "../../../../utils/Config/getDefaultConfig";
import { convertMapToClassname } from "../../../../utils/classStyles";
import { getFieldIcon } from "../../../../utils/getFieldIcon";
import {
  findItemById,
  getOffset,
  getPositionedElementConfig,
  updateClassesInLayout,
  updateOnlyElementConfigInLayout
} from "../../../FlexibleLayout/utils";
import PositionedScreen from "../../../FlexibleLayout/PositionedScreen";
import { EditSingleTileOfBlock } from "../../ChartRenderer/BlockTiles";
import { EditChartData, EditChartLabel, EditChartStyles } from "../../ChartRenderer/EditChartConfig";
import DetailsviewElementsBar from "../../DetailsViewRenderer/Desktop/DetailsviewElementsBar";
import DetailviewLayoutEditor from "../../DetailsViewRenderer/Desktop/DetailviewLayoutEditor";
import RecordsetListCardDesign from "../../DetailsViewRenderer/Desktop/RecordsetListCardDesign";
import { HiddenColumns } from "../Mobile/MobileRecordEditSection";
import "./NewDesktopRecordsview.css";
import { CustomColumnGroupData } from "./RecordsViewEdit/Columns/EditCustomColumn";
import EditFieldColumn from "./RecordsViewEdit/Columns/EditFieldColumn";
import EditActions from "./RecordsViewEdit/EditActions";
import RecordviewPageActionsHandler from "./RecordviewPageActionsHandler";
import FieldSelectorFromPopup from "../../../../components/BuilderComponents/FieldSelectorFromPopup";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import { generateObjectId } from "../../../../utils/objectIdUtils";
import { toastError } from "../../../../utils/toastUtils";
const NewDesktopRecordviewRenderer = () => {
  const { blockData } = useAppBlocksContext();

  if (!blockData || !blockData.id) return;
  return (
    <div>
      <RecordviewPageActionsHandler />
      <RVMainContainer />
    </div>
  );
};

const RVMainContainer = () => {
  const [selectedEditSection, setSelectedEditSection] = useState("table");
  const [selectedSmallTab, setSelectedSmallTab] = useState("table");

  const changedEditSection = (to) => {
    setSelectedEditSection(to);
  };

  const changedSmallTab = (to) => {
    setSelectedSmallTab(to);
  };
  return (
    <div className="recordview_main_container">
      <div className={`rvmain_section ${selectedEditSection !== "table" ? "hidden" : ""}`}>
        {selectedEditSection === "table" && (
          <RVMainEditSection
            changedEditSection={changedEditSection}
            changedSmallTab={changedSmallTab}
            selectedSmallTab={selectedSmallTab}
          />
        )}
      </div>
      <div className={`rvcatalog_section ${selectedEditSection === "catalog" ? "active" : ""}`}>
        {selectedEditSection === "catalog" && <RVCatalogEditSection changedEditSection={changedEditSection} />}
      </div>
    </div>
  );
};

const RVCatalogEditSection = ({ changedEditSection }) => {
  const [dragFromOutside, setDragFromOutside] = useState(false);
  const { blockData } = useAppBlocksContext();
  const [tableObj, setTableObj] = useState({});
  const { getTableTypeData } = useTableContext();

  const handleDragStart = (e, name, id, type) => {
    setDragFromOutside(true);
    e.dataTransfer.setData("id", id);
    e.dataTransfer.setData("type", type);
    e.dataTransfer.setData("name", name);
  };

  useEffect(() => {
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(blockData?.table_type, blockData?.config?.layout?.table_id);
      setTableObj(tableObject);
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="detailsView_outer_wrap d_flex">
      <div className="flex_column w_100">
        <button
          className="material-symbols-outlined px_3 cursor_pointer pt_3 catalog_view_back"
          onClick={() => changedEditSection("table")}
        >
          <Button variant="secondary" size="small">
            <MaterialIcon name="arrow_back_ios" className="cursor_pointer" style={{ fontSize: "16px" }} />
            <span style={{ fontSize: "12px", fontWeight: "500" }}>Back</span>
          </Button>
        </button>
        <div className="desktop_draggable_field_outer">
          <div
            id="droppableContainerWidth"
            className="droppable_container border_radius_medium "
            style={{ padding: "0px 20px 20px 20px" }}
          >
            <DetailviewLayoutEditor
              dragFromOutside={dragFromOutside}
              setDragFromOutside={setDragFromOutside}
              tableRef={{ current: tableObj }}
              device={"desktop"}
              tableID={blockData?.config?.layout?.table_id}
              tableType={blockData?.config?.layout?.table_type}
            />
          </div>
        </div>
      </div>

      <DetailsviewElementsBar handleDragStart={handleDragStart} device={"desktop"} />
    </div>
  );
};

const RVMainEditSection = ({ changedEditSection, changedSmallTab, selectedSmallTab }) => {
  const { blockData, blockDataDispatch } = useAppBlocksContext();
  const { pre_filters, default_sort, tiles, charts, hidden_columns, column_pre_filters, on_row_action } =
    blockData?.config?.layout || {};

  const [toggleRvBlock, setToggleRvBlock] = useState({
    preFilters: !!pre_filters?.length,
    preSort: !!default_sort?.length,
    tiles: !!tiles?.length,
    charts: !!charts?.length,
    hiddenColumns: !!hidden_columns?.length,
    columnPreFilters: !!column_pre_filters?.length,
    onRowClickJob: !!on_row_action?.job_id
  });

  const listOfBlocks = [
    { name: "Pre Filters", state: "preFilters", count: pre_filters?.length || 0 },
    { name: "Pre Sort", state: "preSort", count: default_sort?.length || 0 },
    { name: "Tiles", state: "tiles", count: tiles?.length || 0 },
    { name: "Charts", state: "charts", count: charts?.length || 0 },
    { name: "Hidden Columns", state: "hiddenColumns", count: hidden_columns?.length || 0 },
    { name: "Column Pre Filters", state: "columnPreFilters", count: column_pre_filters?.length || 0 },
    { name: "On Row Job", state: "onRowClickJob", count: on_row_action?.job_id ? 1 : 0 }
  ];

  const handleChangeToggleBlock = (stateName, value) => {
    const block = listOfBlocks.find((block) => block.state === stateName);

    if (block && block.count > 0 && !value) {
      return;
    }

    setToggleRvBlock({ ...toggleRvBlock, [stateName]: value });
  };

  const handleChangePrefilters = (type, data) => {
    if (type === "prefilter") {
      blockDataDispatch({ type: "PRE_FILTERS", payload: data });
    }
    if (type === "owner_pre_filters") {
      blockDataDispatch({ type: "OWNER_PRE_FILTERS", payload: data });
    }
  };
  const handleChangeDefaultSort = (data) => {
    blockDataDispatch({ type: "DEFAULT_SORT", payload: data });
  };
  const handleChangeTiles = (tiles) => {
    blockDataDispatch({ type: "BLOCK_TILES", payload: tiles });
  };
  const handleChangeCharts = (charts) => {
    blockDataDispatch({ type: "BLOCK_CHARTS", payload: charts });
  };
  return (
    <div className="rv_table_section p_3">
      <div className="d_flex gap_4 align_center">
        {listOfBlocks.map(({ name, state, count }) => (
          <div className="d_flex gap_2 align_center" key={name}>
            <div className="d_flex gap_1 justify_center align_center">
              <Label>{name}</Label>
              {count !== 0 && (
                <span
                  className="d_flex gap_1 justify_center align_center"
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "100%",
                    backgroundColor: "var(--builder-active)",
                    border: "1px solid var(--builder-border)"
                  }}
                >
                  {count}
                </span>
              )}
            </div>
            <Toggle value={toggleRvBlock[state]} onChange={(e) => handleChangeToggleBlock(state, e.target.checked)} />
          </div>
        ))}
      </div>
      <div className="rv_prefilter_sort_container">
        {toggleRvBlock.preFilters && (
          <div className="position_relative">
            <Label
              className="position_absolute font_weight_semibold"
              style={{
                top: "-12px",
                left: "20px",
                padding: "4px",
                display: blockData?.config?.layout?.pre_filters?.length > 0 ? "none" : "block"
              }}
            >
              Pre Filters
            </Label>
            <EditPrefilterWithSummary
              prefiltersWithFormula={{
                prefilter: blockData?.config?.layout?.pre_filters || [],
                prefilters_joined_by: blockData?.config?.layout?.prefilters_joined_by || "",
                owner_pre_filters: blockData?.config?.layout?.owner_pre_filters || {}
              }}
              handleChange={handleChangePrefilters}
              tableId={blockData?.config?.layout?.table_id || ""}
              activityId={blockData?.config?.layout?.activity_id || ""}
              tableType={blockData?.table_type || ""}
            />
          </div>
        )}
        {toggleRvBlock.preSort && (
          <div className="position_relative">
            <Label
              className="position_absolute font_weight_semibold"
              style={{
                top: "-12px",
                left: "20px",
                padding: "4px",
                display: blockData?.config?.layout?.default_sort?.length > 0 ? "none" : "block"
              }}
            >
              Pre Sort
            </Label>
            <EditPreSortWithSummary
              defaultSort={blockData?.config?.layout.default_sort || []}
              handleChangeDefaultSort={handleChangeDefaultSort}
              tableId={blockData?.config?.layout?.table_id || ""}
              activityId={blockData?.config?.layout?.activity_id || ""}
              tableType={blockData?.table_type || ""}
            />
          </div>
        )}
      </div>
      <div className="recordview_user_viwer_container">
        {toggleRvBlock.charts && (
          <EditBlockChartWithSummary
            charts={blockData?.config?.layout.charts || []}
            handleChangeCharts={handleChangeCharts}
            tableId={blockData?.config?.layout?.table_id || ""}
            activityId={blockData?.config?.layout?.activity_id || ""}
            tableType={blockData?.table_type || ""}
          />
        )}
        {toggleRvBlock.tiles && (
          <EditBlockTilesWithSummary
            tiles={blockData?.config?.layout.tiles || []}
            handleChangeTiles={handleChangeTiles}
            tableId={blockData?.config?.layout?.table_id || ""}
            activityId={blockData?.config?.layout?.activity_id || ""}
            tableType={blockData?.table_type || ""}
          />
        )}
        <RVTableAndCatalogToggle
          changedEditSection={changedEditSection}
          changedSmallTab={changedSmallTab}
          selectedSmallTab={selectedSmallTab}
          toggleRvBlock={toggleRvBlock}
        />
      </div>
      {toggleRvBlock.columnPreFilters && (
        <div className="d_flex justify_between">
          <ColumnPreFiltersWithSummary />
        </div>
      )}
    </div>
  );
};

const ColumnPreFiltersWithSummary = () => {
  const [isRightbarOpen, setIsRightbarOpen] = useState(false);
  const { blockData, blockDataDispatch } = useAppBlocksContext();

  const closeEditBar = () => {
    setIsRightbarOpen(false);
  };

  const handleChangeColumnPreFilters = (data) => {
    blockDataDispatch({ type: "COLUMN_PRE_FILTERS", payload: { value: data } });
  };

  return (
    <div>
      <div className="d_flex gap_3 p_3 align_center">
        <MaterialIcon name="filter_list" />
        <span>No column pre-filter added</span>
        <Button
          variant="secondary"
          style={{ width: "24px", height: "24px" }}
          size="small"
          onClick={() => setIsRightbarOpen(true)}
        >
          <MaterialIcon name="add" style={{ fontSize: "12px" }} />
        </Button>
      </div>
      <BuilderRightSideBar isOpen={isRightbarOpen} onClose={closeEditBar} heading="Edit Column Prefilter">
        <ColumnPreFilters
          columnList={blockData?.config?.layout?.columns || []}
          tableId={blockData?.config?.layout?.table_id}
          columnPreFilters={blockData?.config?.layout?.column_pre_filters || []}
          setColumnPreFilters={handleChangeColumnPreFilters}
        />
      </BuilderRightSideBar>
    </div>
  );
};

const RVTableAndCatalogToggle = ({ changedEditSection, selectedSmallTab, changedSmallTab, toggleRvBlock }) => {
  const { blockData, blockDataDispatch } = useAppBlocksContext();
  const { blocksExplorerData } = useTreeContext();

  const layoutType = blockData?.config?.layout?.layout_type || "";
  const tabArray = ["table_and_catalog_view", "catalog_and_table_view"];

  const handleChangeTabAcccordingType = (type) => {
    if (tabArray.includes(type) || type === "table_view" || type === "") {
      changedSmallTab("table");
    } else if (type === "catalog_view") {
      changedSmallTab("catalog");
    } else if (type === "embedded") {
      changedSmallTab("embedded");
    }
  };

  const handleChange = (name, value) => {
    if (name === "layout_type") {
      handleChangeTabAcccordingType(value);
    }
    blockDataDispatch({ type: "UPDATE_ACTION_PERMISSIONS", payload: { value, name } });
  };

  const handleChangeMultiJobActions = (actions) => {
    blockDataDispatch({ type: "UPDATE_MULTI_SELECT_CUSTOM_ACTIONS", payload: actions });
  };

  const getAllDetailsViewList = () => {
    const data = blocksExplorerData
      .find((deviceData) => deviceData.id === blockData.device)
      .items.find((detailview) => detailview.id.includes("detailsview")).items;
    const statemachineDetsilsview = data.filter(
      (detailview) => detailview.fileInfo?.table_id === blockData.config.layout.table_id
    );
    return statemachineDetsilsview;
  };

  const layoutOptions = [
    { id: "table_view", name: "table view only" },
    { id: "catalog_view", name: "catalog view only" },
    { id: "embedded", name: "embedded" },
    { id: "table_and_catalog_view", name: "table and catalog view" },
    { id: "catalog_and_table_view", name: "catalog and table view" }
  ];
  const handleChangeDataLimit = (e) => {
    blockDataDispatch({ type: "DATA_LIMIT", payload: { value: parseInt(e.target.value) } });
  };
  const handleChangeEmbeddedDVId = (id) => {
    blockDataDispatch({ type: "UPDATE_EMBEDDED_DV_ID", payload: id });
  };
  const handleChangeHiddenColumn = (column) => {
    blockDataDispatch({ type: "HIDDEN_COLUMNS", payload: column });
  };
  const handleChangeOnRowAction = (data) => {
    blockDataDispatch({ type: "ON_ROW_ACTION", payload: data });
  };

  useEffect(() => {
    handleChangeTabAcccordingType(layoutType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="recordview_table_catalog_toggle_container">
        <div className="d_flex gap_2">
          {tabArray.includes(layoutType) && (
            <>
              <div
                onClick={() => changedSmallTab("table")}
                className={`${selectedSmallTab === "table" ? "tab_active" : ""} p_2`}
              >
                Table view
              </div>
              <div
                onClick={() => changedSmallTab("catalog")}
                className={`${selectedSmallTab === "catalog" ? "tab_active" : ""} p_2`}
              >
                Catalog view
              </div>
            </>
          )}
        </div>
        <div className="d_flex gap_3 pb_2 align_center">
          <SingleSelectBox
            selectedData={blockData?.config?.layout?.layout_type || ""}
            options={layoutOptions}
            onChange={(obj) => handleChange("layout_type", obj.id)}
            placeholder="Layout Type"
            containerStyle={{ width: "200px" }}
          />
          <Label>Hide header</Label>
          <Toggle
            value={blockData?.config?.layout?.hide_header}
            onChange={(e) => handleChange("hide_header", e.target.checked)}
          />
          <Label>Hide Footer</Label>
          <Toggle
            value={blockData?.config?.layout?.hide_footer}
            onChange={(e) => handleChange("hide_footer", e.target.checked)}
          />
        </div>
      </div>
      {!blockData?.config?.layout?.hide_header && (
        <>
          <EditActionPermissionsForRV selectedLayout={selectedSmallTab} />
          <div className="p_3 d_flex justify_between">
            <div className="w_50">
              <RVOnScreenFilter />
            </div>
            <div className="w_50 d_flex justify_end">
              <MultipleJobActions
                actions={blockData?.config?.layout.multi_select_custom_actions || []}
                tableId={blockData?.config?.layout?.table_id || ""}
                tableType={blockData?.table_type || "statemachine"}
                handleChangeMultiJobActions={handleChangeMultiJobActions}
                elements={[blockData]}
                device={blockData.device}
              />
            </div>
          </div>
        </>
      )}
      {selectedSmallTab === "table" && <EditRVColumns />}
      {selectedSmallTab === "catalog" && <RVCatalogPreview changedEditSection={changedEditSection} />}
      {selectedSmallTab === "embedded" && (
        <div className="px_3 w_25">
          <SingleSelectBox
            selectedData={blockData?.config?.layout?.catalog?.embedded_detailview?.detailview_id || ""}
            options={getAllDetailsViewList()}
            onChange={(obj) => handleChangeEmbeddedDVId(obj.id)}
            placeholder="select detailsview"
            label="Select Detailsview"
          />
        </div>
      )}
      {layoutType !== "embedded" && toggleRvBlock.onRowClickJob && (
        <div className="position_relative">
          <Label
            className="position_absolute font_weight_semibold"
            style={{ top: "-12px", left: "20px", backgroundColor: "white", padding: "4px" }}
          >
            On Row Job
          </Label>
          <RVOnRowAction
            job={blockData?.config?.layout?.on_row_action || null}
            onChange={handleChangeOnRowAction}
            tableId={blockData?.config?.layout?.table_id}
            tableType={blockData?.table_type || "statemachine"}
            device={"desktop"}
          />
        </div>
      )}
      <div className="d_flex justify_between px_3">
        {toggleRvBlock.hiddenColumns ? (
          <HiddenColumns
            columns={blockData?.config?.layout?.hidden_columns || []}
            handleChange={handleChangeHiddenColumn}
            tableId={blockData?.config?.layout?.table_id}
          />
        ) : (
          <div></div>
        )}
        {!blockData?.config?.layout?.hide_footer && (
          <Input
            label="Data Limit"
            type="number"
            value={blockData?.config?.layout?.data_limit || 0}
            onChange={handleChangeDataLimit}
            containerStyle={{ width: "auto" }}
          />
        )}
      </div>
    </div>
  );
};

const RVCatalogPreview = ({ changedEditSection }) => {
  const { blockData } = useAppBlocksContext();
  // const [previewData, setPreviewData] = useState([]);
  const numberOfCardsPerRow = blockData?.config?.layout?.catalog?.catalog_in_row || 1;
  //TODO: add actual preview
  // useEffect(() => {
  //   let detailviewConfig = getDetailviewConfig();
  //   detailviewConfig = detailviewConfig?.elements || [];
  //   setPreviewData(detailviewConfig);
  // }, [])
  return (
    <div className="d_flex gap_3 px_3 w_100">
      {Array.from({ length: numberOfCardsPerRow }).map((_, index) => (
        <div key={index} className="recordview_catalog_card_preview" onClick={() => changedEditSection("catalog")}>
          {/* <DetailsviewPreview detailviewConfig={previewData} /> */}
          <Button variant="secondary" size="medium">
            Click to edit
          </Button>
        </div>
      ))}
    </div>
  );
};

const RVOnRowAction = ({ job, onChange, tableId, device, tableType }) => {
  // const { blockData, blockDataDispatch } = useAppBlocksContext();
  const { axiosInstance, handleError } = useAxiosContext();
  const [allJobs, setAllJobs] = useState([]);

  // const handleJobTriggerData = (data) => {
  //   blockDataDispatch({ type: "ON_ROW_ACTION", payload: data });
  // };

  useEffect(() => {
    const fetchAllTemplatesAndJobs = async () => {
      try {
        const { data } = await axiosInstance.get(`/jobs/filter/?places=details_view&elements=button`);
        setAllJobs(data);
      } catch (error) {
        handleError(error);
      }
    };
    fetchAllTemplatesAndJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="recordview_summary_container d_flex justify_center">
      <div className="d_flex align_center gap_3">
        {!job?.job_id && (
          // {!blockData?.config?.layout?.on_row_action?.job_id && (
          <div className="d_flex align_center gap_3">
            <MaterialIcon name="highlight_mouse_cursor" />
            <span>No on row click job is added</span>
          </div>
        )}
        <SingleJobPopup
          config={job}
          allJobs={allJobs}
          smId={tableId}
          device={device}
          onChange={onChange}
          type={tableType}
        />
      </div>
    </div>
  );
};

const EditRVColumns = () => {
  const { blockData, blockDataDispatch } = useAppBlocksContext();
  const initialEditbarOpen = {
    show: false,
    index: null,
    data: null,
    type: ""
  };
  const initialMoallOpen = {
    show: false,
    type: "",
    action: "",
    index: null,
    data: null
  };
  const [isEditbarOpen, setIsEditbarOpen] = useState(initialEditbarOpen);
  const [isModalOpen, setIsModalOpen] = useState(initialMoallOpen);
  const { getTableTypeData } = useTableContext();
  const tableRef = useRef({});

  const closeModal = () => {
    setIsModalOpen(initialMoallOpen);
  };

  const closeEditbar = () => {
    setIsEditbarOpen(initialEditbarOpen);
  };

  const handleChangeColumns = (payload) => {
    const { action, type, index, column, elementIndex, elementConfig, allColumns } = payload;
    if (action === "sort") {
      blockDataDispatch({ type: "SORT_COLUMN", payload: { allColumns } });
    }
    if (action === "delete") {
      blockDataDispatch({ type: "DELETE_COLUMN", payload: { index } });
    }
    if (action === "edit") {
      setIsEditbarOpen({ show: true, index: index, data: column, type });
    }
    if (action === "add" || action === "change") {
      setIsModalOpen({ type, action, show: true, index: index });
    }
    if (action === "edit_custom_button") {
      setIsEditbarOpen({
        show: true,
        index: index,
        elementIndex: elementIndex,
        data: elementConfig,
        type: "custom_button"
      });
    }
    if (action === "recordset_layout") {
      setIsModalOpen({
        show: true,
        action: "recordset_layout",
        index: index,
        data: column,
        type: column.field_type
      });
    }
    if (action === "delete_custom_button") {
      blockDataDispatch({ type: "DELETE_BUTTON_CUSTOM_COLUMN", payload: { index: index, elementIndex: elementIndex } });
    }
  };

  const handleSingleFieldAddChange = (data) => {
    if (blockData?.config?.layout?.columns.some((field) => field.id === data.id)) {
      toastError("Field already exists");
      return;
    }
    if (isModalOpen.action === "add") {
      blockDataDispatch({ type: "ADD_COLUMN", payload: { index: isModalOpen.index, value: data } });
      closeModal();
    }
    if (isModalOpen.action === "change") {
      blockDataDispatch({ type: "CHANGE_COLUMN", payload: { index: isModalOpen.index, value: data } });
      closeModal();
    }
    if (isModalOpen.action === "add_multiple") {
      blockDataDispatch({ type: "ADD_COLUMN", payload: { index: isModalOpen.index, value: data } });
    }
  };

  const handleAddColumn = (data) => {
    if (data.type === "field") {
      setIsModalOpen({
        type: "field",
        action: "add_multiple",
        show: true,
        index: blockData?.config?.layout?.columns.length
      });
    }
    if (data.type === "custom") {
      blockDataDispatch({
        type: "ADD_COLUMN",
        payload: { index: blockData?.config?.layout?.columns.length, value: data.column }
      });
      setIsEditbarOpen({ show: true, index: blockData?.config?.layout?.columns.length, type: "custom" });
    }
  };

  const handleChangeField = (data) => {
    blockDataDispatch({ type: "EDIT_COLUMN", payload: { index: isEditbarOpen.index, value: data } });
  };

  const handleChangeCustomColumn = (data, payload) => {
    blockDataDispatch({ type: "EDIT_COLUMN", payload: { index: isEditbarOpen.index, value: data } });
    if (payload && payload.type === "button" && payload.action === "add") {
      setIsEditbarOpen({
        show: true,
        index: isEditbarOpen.index,
        elementIndex: data.config.length - 1,
        data: payload.value,
        type: "custom_button"
      });
    }
  };

  const handleChangeCustomButton = (data) => {
    blockDataDispatch({
      type: "EDIT_BUTTON_CUSTOM_COLUMN",
      payload: { index: isEditbarOpen.index, elementIndex: isEditbarOpen.elementIndex, value: data }
    });
  };

  const handleSaveRecordsetLayout = (data) => {
    blockDataDispatch({ type: "EDIT_RECORDSET_LAYOUT", payload: { index: isModalOpen.index, value: data } });
    closeModal();
  };
  useEffect(() => {
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(blockData?.table_type, blockData?.config?.layout?.table_id);
      tableRef.current = tableObject;
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="position_relative">
        <RVTableAddFieldActions handleAddColumn={handleAddColumn} />
        <RVTableViewColumns
          columns={blockData?.config?.layout?.columns || []}
          handleChangeColumns={handleChangeColumns}
        />
      </div>
      <BuilderRightSideBar
        isOpen={isEditbarOpen.show}
        heading="Edit Column"
        onClose={closeEditbar}
        style={{ width: "384px" }}
      >
        {isEditbarOpen.type === "field" && (
          <div>
            <EditFieldColumn
              field={blockData?.config?.layout?.columns[isEditbarOpen.index]}
              tableId={blockData?.config?.layout?.table_id}
              tableType={blockData?.table_type}
              handleChangeField={handleChangeField}
            />
          </div>
        )}
        {isEditbarOpen.type === "custom" && (
          <div className="p_3 flex_column gap_3">
            <EditCustomColumn
              field={blockData?.config?.layout?.columns[isEditbarOpen.index]}
              handleChangeField={handleChangeCustomColumn}
              tableId={blockData?.config?.layout?.table_id || ""}
              tableType={blockData?.table_type || ""}
            />
          </div>
        )}
        {isEditbarOpen.type === "custom_button" && (
          <EditButtonConfig
            editElementRightsidebar={{
              type: blockData?.config?.layout?.columns[isEditbarOpen.index].config[isEditbarOpen.elementIndex].type,
              config: blockData?.config?.layout?.columns[isEditbarOpen.index].config[isEditbarOpen.elementIndex],
              id: blockData?.config?.layout?.columns[isEditbarOpen.index].config[isEditbarOpen.elementIndex].id,
              elements: [blockData]
            }}
            onSave={handleChangeCustomButton}
            places="records_view_row"
            device="desktop"
            smId={blockData?.config?.layout?.table_id}
            type={blockData?.table_type || "statemachine"}
          />
        )}
      </BuilderRightSideBar>
      <BuilderModal isOpen={isModalOpen.show} onClose={closeModal} modalName="Add New Column">
        {(isModalOpen.action === "add_multiple" || isModalOpen.action === "change" || isModalOpen.action === "add") && (
          <TableTreeModal callbackFunction={handleSingleFieldAddChange} tableId={blockData?.config?.layout?.table_id} />
        )}
        {isModalOpen.action === "recordset_layout" && (
          <RecordsetListCardDesign
            tableRef={tableRef}
            layoutData={isModalOpen.data?.layout_config?.layouts || []}
            folderId={[isModalOpen.data?.id]}
            handleSaveRecordsetLayout={handleSaveRecordsetLayout}
            tableId={blockData?.config?.layout?.table_id}
            tableType={blockData?.config?.layout?.table_type}
            device={blockData?.device || "desktop"}
          />
        )}
      </BuilderModal>
    </div>
  );
};

const EditCustomColumn = ({ field, handleChangeField, tableId, tableType }) => {
  const { getTableTypeData } = useTableContext();
  const [tableObj, setTableObj] = useState({});

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    type: "",
    name: ""
  });

  const closeModal = () => {
    setIsModalOpen({ show: false, type: "" });
  };

  const widthOptions = [
    { id: "width", name: "width" },
    { id: "max_width", name: "max width" },
    { id: "min_width", name: "min width" }
  ];
  const handleChange = (name, value) => {
    handleChangeField({ ...field, [name]: value }, { action: "edit", type: field?.custom_type, name, value });
  };

  const addElementToCustomColumn = (type) => {
    const obj = getDefaultConfig(type);
    if (!obj) {
      console.error("Failed to get default config for type:", type);
      return;
    }
    obj.id = generateObjectId();

    const newColumn = {
      ...field,
      config: [...(field?.config || []), obj]
    };

    handleChangeField(newColumn, { action: "add", type: field?.custom_type, name: "config", value: obj });
  };

  const getLayoutDataForColumn = () => {
    if (!field.layout_config || !field.layout_config.layouts) {
      return [];
    }
    return field.layout_config.layouts;
  };

  const handleSaveRecordsetLayout = (data) => {
    // const newColumn = { ...field, layout_config: { ...field.layout_config, layouts: data } };
    const newColumn = {
      ...field,
      layout_config: { ...field.layout_config, layout_width: data.layout_width, layouts: data.layouts }
    };

    handleChangeField(newColumn, { action: "change", type: field?.custom_type, name: "layouts", value: data });
    closeModal();
  };
  const handleSaveNewRichCell = (layout) => {
    const newColumn = {
      ...field,
      layout_config: { ...field.layout_config, layouts: layout }
    };
    handleChangeField(newColumn, { action: "change", type: field?.custom_type, name: "layouts", value: layout });
    closeModal();
  };

  const handleAggrigateColumn = (data) => {
    const copyObj = { ...field };
    copyObj.aggregate_column = data.id;
    handleChangeField(copyObj, { action: "change", type: field?.custom_type, name: "layouts", value: data });
    closeModal();
  };

  const aggregateFunctionOptions = [
    { id: "", name: "none" },
    { id: "sum", name: "sum" },
    { id: "count", name: "count" },
    { id: "count_if", name: "count if" }
  ];

  const handleChangeInAggrigateFunction = (data) => {
    handleChangeField(data);
  };

  useEffect(() => {
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(tableType, tableId);
      setTableObj(tableObject);
    };
    fetchTable();
    // setLayoutConfig(field?.layout_config?.layouts || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Input
        label="Column Label"
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        name="display"
        value={field?.display || ""}
      />
      <SingleSelectBox
        selectedData={field?.width_type || ""}
        options={widthOptions}
        onChange={(obj) => handleChange("width_type", obj.id)}
        placeholder="select"
        label="Select width type"
      />
      {field?.width_type && (
        <>
          <Input
            label="Width(in pixels)"
            type="number"
            name="width_value"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            value={field?.width_value || ""}
          />
        </>
      )}
      {(!field.custom_type || field?.custom_type === "button") && (
        <div className="custom_type_selector_container">
          <div className="config_child_header_container">
            <p className="config_child_header_title">Add Button</p>
          </div>
          <div className="custom_type_menu_container">
            <Button variant="plain" onClick={() => addElementToCustomColumn("button")}>
              Button
            </Button>
            <Button variant="plain" onClick={() => addElementToCustomColumn("dropdown")}>
              <p>Dropdown</p>
              <MaterialIcon name="expand_more" />
            </Button>
          </div>
        </div>
      )}
      {field?.custom_type === "rich_column" && (
        <Button
          variant="secondary"
          onClick={() => setIsModalOpen({ show: true, type: "rich_column", name: "Create Rich Cell" })}
        >
          Edit Column
        </Button>
      )}
      {field?.custom_type === "new_rich_column" && (
        <Button
          variant="secondary"
          onClick={() => setIsModalOpen({ show: true, type: "new_rich_column", name: "Create New Rich Cell" })}
        >
          Edit New Column
        </Button>
      )}
      {field?.custom_type === "aggregate_column" && (
        <>
          <div className="builder_form">
            <div className="flex_column gap_1">
              <label className="builder_label">Aggregate Column</label>
              <div
                className="builder_displayBox"
                onClick={() =>
                  setIsModalOpen({ show: true, type: "aggregate_column", name: "Select Aggrigate Column" })
                }
              >
                <div>
                  {field?.aggregate_column
                    ? tableObj[field?.aggregate_column]?.prefix + "." + tableObj[field?.aggregate_column]?.display
                    : "No field assign"}
                </div>
              </div>
            </div>
            <SingleSelectBox
              selectedData={field.aggregate_function}
              options={aggregateFunctionOptions}
              onChange={(obj) => handleChange("aggregate_function", obj.id)}
              placeholder="none"
              label="Aggregate Function"
            />
            {(field.aggregate_function === "sum_if" || field.aggregate_function === "count_if") && (
              <div className="flex_column gap_1">
                <CustomColumnGroupData
                  field={field}
                  handleChange={handleChangeInAggrigateFunction}
                  allTableColumns={tableObj}
                  tableId={tableId}
                />
              </div>
            )}
          </div>
        </>
      )}
      <BuilderModal isOpen={isModalOpen.show} onClose={closeModal} modalName={isModalOpen.name}>
        {isModalOpen.type === "aggregate_column" && (
          <TableTreeModal
            callbackFunction={handleAggrigateColumn}
            tableId={tableId}
            selectedFile={
              tableObj && field?.custom_type === "aggregate_column" && field?.aggregate_column
                ? tableObj[field?.aggregate_column]?.id
                : ""
            }
          />
        )}
        {isModalOpen.type === "rich_column" && (
          <RecordsetListCardDesign
            tableRef={{ current: tableObj }}
            layoutData={getLayoutDataForColumn()}
            layoutWidth={field?.layout_config?.layout_width}
            modalType={"rich-column"}
            tableId={tableId}
            handleSaveRecordsetLayout={handleSaveRecordsetLayout}
            device="desktop"
          />
        )}
        {isModalOpen.type === "new_rich_column" && (
          <RichColumnInRv
            width={field?.width_value || 250}
            layout={field?.layout_config?.layouts || []}
            handleSaveNewRichCell={handleSaveNewRichCell}
            tableId={tableId}
            tableType={tableType}
            device="desktop"
          />
        )}
      </BuilderModal>
    </>
  );
};

const RichColumnInRv = ({ width, layout, handleSaveNewRichCell, tableId, tableType }) => {
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [draggedItem, setDraggedItem] = useState(null);
  const [layoutConfig, setLayoutConfig] = useState(layout);
  const initialStateOfEditBat = {
    id: "",
    type: "",
    show: false,
    device: "",
    config: null,
    elements: null
  };
  const [editElement, setEditElement] = useState(initialStateOfEditBat);
  const [isEditable, setIsEditable] = useState("editable");
  const [selectedItem, setSelectedItem] = useState(null);
  const [gridSize, setGridSize] = useState(12);
  const { blockData } = useAppBlocksContext();

  const toggleMode = () => {
    setSelectedItem(null);
    setIsEditable(isEditable === "editable" ? "view" : "editable");
  };
  const handleChangeGridSize = (e) => {
    setGridSize(parseInt(e.target.value));
  };

  const openEditBar = (selectedItem) => {
    const element = findItemById(layoutConfig, selectedItem.id);

    if (element.type === "element") {
      setEditElement({
        id: element.id,
        type: element.config.type,
        show: true,
        device: "desktop",
        config: element.config || null,
        elements: [blockData],
        baseElement: element
      });
    }

    if (element.type === "section" || element.type === "column" || element.type === "block") {
      setEditElement({
        id: element.id,
        type: element.type,
        show: true,
        device: "desktop",
        config: element.config || {},
        elements: [blockData],
        baseElement: element
      });
    }
  };
  const handleChangesInClasses = (newClasses, elementId) => {
    const newLayout = updateClassesInLayout(layoutConfig, elementId, newClasses);
    setLayoutConfig(newLayout);
  };

  const saveEditElement = (config) => {
    const newLayout = updateOnlyElementConfigInLayout(layoutConfig, editElement.id, config);
    setLayoutConfig(newLayout);
  };

  const closeEditBar = () => {
    setEditElement(initialStateOfEditBat);
    setSelectedItem(null);
  };
  const allowedStaticElements = [
    { id: "field", type: "field", name: "Field" },
    { id: "label", type: "label", name: "Label" },
    { id: "section", type: "section", name: "Section" },
    { id: "spacer", type: "spacer", name: "Spacer" },
    { id: "separator", type: "separator", name: "Separator" },
    { id: "button", type: "button", name: "Button" },
    { id: "html", type: "html", name: "HTML" },
    { id: "progress-tracker", type: "progress-tracker", name: "Progress Tracker" }
  ];

  useEffect(() => {
    if (selectedItem) {
      openEditBar(selectedItem);
    } else {
      closeEditBar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);
  return (
    <div>
      <div className="d_flex justify_between">
        <div className="d_flex gap_2">
          <Button variant="secondary" onClick={toggleMode}>
            {isEditable === "editable" ? "View Mode" : "Edit Mode"}
          </Button>
          <select value={gridSize} onChange={handleChangeGridSize}>
            <option value={6}>6</option>
            <option value={12}>12</option>
            <option value={24}>24</option>
            <option value={48}>48</option>
            <option value={96}>96</option>
          </select>
        </div>
        <Button onClick={() => handleSaveNewRichCell(layoutConfig)}>Save</Button>
      </div>
      <div className="d_flex gap_2">
        <div className="d_flex justify_center" style={{ width: "800px" }}>
          <PositionedScreen
            layoutConfig={layoutConfig || []}
            setLayoutConfig={setLayoutConfig}
            draggedItem={draggedItem}
            setDragOffset={setDragOffset}
            setDraggedItem={setDraggedItem}
            dragOffset={dragOffset}
            openEditBar={openEditBar}
            type={isEditable}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            gridSize={gridSize}
            screenWidth={width}
          />
        </div>
        <CustomElementsBar
          elements={allowedStaticElements}
          setDraggedItem={setDraggedItem}
          setDragOffset={setDragOffset}
        />
      </div>
      <BuilderRightSideBar isOpen={editElement.show} onClose={closeEditBar} heading={editElement.type} size={"small"}>
        <EditPositionFields
          editElementRightsidebar={editElement}
          saveElement={saveEditElement}
          device={"desktop"}
          handleClasses={handleChangesInClasses}
          smId={tableId}
          tableType={tableType}
          jobPlaces="records_view_row"
        />
      </BuilderRightSideBar>
    </div>
  );
};

export const CustomElementsBar = ({ elements = [], setDraggedItem, setDragOffset }) => {
  const handleDragStart = (e, { type }) => {
    e.stopPropagation();
    let newConfig = getPositionedElementConfig(type);
    if (type !== "block" && type !== "section" && type !== "column" && type !== "tabview" && type !== "tab") {
      newConfig.config = elementConfig[type];
    }
    const offset = getOffset(e);
    setDraggedItem(newConfig);
    setDragOffset(offset);
  };

  return (
    <div className="rightsidebar">
      <div className="draggable_formField_rightPanel_outer flex_wrap gap_2" style={{ height: "auto" }}>
        {elements.map((field, index) => (
          <DraggableField key={field.id + "-" + index} field={field} handleDragStart={handleDragStart} />
        ))}
      </div>
    </div>
  );
};

const DraggableField = ({ field, handleDragStart }) => (
  <div
    onDragStart={(e) => handleDragStart && handleDragStart(e, field)}
    draggable={Boolean(handleDragStart)}
    className="draggable_input_field"
  >
    <MaterialIcon name={getFieldIcon(field.type)} />
    <span className="field_name">{field.name}</span>
  </div>
);

const RVTableAddFieldActions = ({ handleAddColumn }) => {
  const [isCustomColumListOpen, setIsCustomColumListOpen] = useState(false);

  const customRef = useRef();

  useClickOutside(customRef, () => setIsCustomColumListOpen(false));

  const addCustomColumn = (e, type) => {
    e.stopPropagation();
    const customColumnConfig = {
      aggregate_column: "",
      aggregate_function: "",
      custom_type: type, //button aggregate_column rich_column
      type: "custom",
      display: "custom",
      config: [],
      layout_config: {
        layouts: []
      },
      id: generateObjectId()
    };
    handleAddColumn({
      type: "custom",
      column: customColumnConfig
    });
    setIsCustomColumListOpen(false);
  };

  return (
    <div className="recordview_add_field_custom_column">
      <Button
        size="small"
        title="Add Field"
        onClick={(e) => {
          e.stopPropagation();
          handleAddColumn({
            type: "field",
            column: null
          });
        }}
      >
        <MaterialIcon name="add" style={{ fontSize: "12px" }} />
      </Button>
      <div className="position_relative" ref={customRef}>
        <Button
          size="small"
          variant="secondary"
          onClick={() => setIsCustomColumListOpen(true)}
          title="Add Custom Column"
        >
          <MaterialIcon name="splitscreen_vertical_add" style={{ fontSize: "12px" }} />
        </Button>
        {isCustomColumListOpen && (
          <div className="recordview_custom_column_option_popover">
            <div onClick={(e) => addCustomColumn(e, "button")}>Button</div>
            <div onClick={(e) => addCustomColumn(e, "aggregate_column")}>Aggregate Column</div>
            <div onClick={(e) => addCustomColumn(e, "rich_column")}>Rich Column</div>
            <div onClick={(e) => addCustomColumn(e, "new_rich_column")}>New Rich Column</div>
          </div>
        )}
      </div>
    </div>
  );
};

const RVTableViewColumns = ({ columns, handleChangeColumns }) => {
  const isMounted = useRef(false); // Track the component mount status

  const setSortableColumns = (columns) => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    const cleanItems = columns.map((item) => {
      // eslint-disable-next-line no-unused-vars
      const { chosen, selected, ...rest } = item;
      return rest;
    });
    const copyColumns = JSON.parse(JSON.stringify(cleanItems));
    handleChangeColumns({
      action: "sort",
      allColumns: copyColumns
    });
  };

  const renderActionIcon = (action, column, index, icon) => (
    <ButtonActionIcon
      size="xsm"
      type={icon}
      onClick={(e) => {
        e.stopPropagation();
        handleChangeColumns({
          action,
          index,
          column,
          type: column.type
        });
      }}
    />
  );

  return (
    <div className="recordview_tableview_table">
      <table>
        <thead style={{ /* backgroundColor: "#E4E7EC"*/ backgroundColor: "var(--builder-active)" }}>
          {columns.length > 0 && (
            <ReactSortable
              tag="tr"
              list={JSON.parse(JSON.stringify(columns))}
              setList={setSortableColumns}
              animation={200}
            >
              {columns.map((column, index) => (
                <th
                  key={column.id + index}
                  className="recordview_table_column_header"
                  title={(column?.prefix ? column.prefix + "." : "") + (column?.display || "----")}
                >
                  <div className="d_flex align_center gap_2">
                    <MaterialIcon name={getFieldIcon(column.field_type)} className="font_size_medium" />
                    <span>{column.custom_label || column.display || "----"}</span>
                  </div>
                  <div className="recordview_table_column_action">
                    {renderActionIcon("edit", column, index, "edit")}
                    {renderActionIcon("change", column, index, "refresh")}
                    {(column.field_type === "grid" ||
                      column.field_type === "recordset" ||
                      column.field_type === "recordset-list") &&
                      renderActionIcon("recordset_layout", column, index, "list_alt")}
                    {renderActionIcon("delete", column, index, "delete")}
                    <div className="recordview_table_column_add_action">
                      {renderActionIcon("add", column, index, "add")}
                    </div>
                  </div>
                </th>
              ))}
            </ReactSortable>
          )}
          {columns.length === 0 && (
            <tr>
              <th>----</th>
              <th>----</th>
              <th>----</th>
              <th>----</th>
            </tr>
          )}
        </thead>
        <tbody>
          {[1, 2, 3, 4, 5, 6, 7, 8].map((row, rowIndex) => (
            <tr key={row + rowIndex}>
              {(columns.length > 0 ? columns : Array.from({ length: 4 })).map((column, colIndex) => {
                if (column && column.type === "custom" && (!column.custom_type || column.custom_type === "button")) {
                  return (
                    <td key={colIndex}>
                      <div className="d_flex gap_2 align_center">
                        {column.config.map((config, elementIndex) => {
                          const isTertiarySize3 =
                            config.className?.type === "builder_btn_tertiary" &&
                            config.className?.size === "button-size3";
                          const className = isTertiarySize3
                            ? `${convertMapToClassname({ ...config.className, type: "builder_btn_tertiary" })}` // Ensure builder_btn_tertiary is applied
                            : `${convertMapToClassname(config.className || {})}`;
                          return (
                            <button
                              key={elementIndex}
                              onClick={() =>
                                handleChangeColumns({
                                  action: "edit_custom_button",
                                  index: colIndex,
                                  elementIndex: elementIndex,
                                  elementConfig: config,
                                  column,
                                  type: column.type
                                })
                              }
                              className={className}
                            >
                              <div className="d_flex align_center gap_2">
                                <IconPreview icon={config.icon || ""} />
                                {config.name}
                                <MaterialIcon
                                  name="close"
                                  className="font_size_medium"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleChangeColumns({
                                      action: "delete_custom_button",
                                      index: colIndex,
                                      elementIndex: elementIndex,
                                      elementConfig: config,
                                      column,
                                      type: column.type
                                    });
                                  }}
                                />
                              </div>
                            </button>
                          );
                        })}
                      </div>
                    </td>
                  );
                }
                // if (column && column.type === "custom" && column.custom_type === "rich_column") {
                //   return <EditRichColumn column={column} />;
                // }
                // Render non-custom columns with default placeholder
                return <td key={colIndex}>---</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const MultipleJobActions = ({
  actions,
  handleChangeMultiJobActions,
  tableId,
  tableType = "statemachine",
  elements,
  device
}) => {
  const [isEditbarOpen, setIsEditbarOpen] = useState({
    show: false
  });
  const closeEditBar = () => {
    setIsEditbarOpen({ show: false });
  };
  const handleChangeAction = (data) => {
    handleChangeMultiJobActions(data);
  };
  return (
    <div>
      <div className="d_flex gap_2 align_center">
        <SummaryOfMultipleJobActions actions={actions} />
        <Button size="small" variant="secondary" onClick={() => setIsEditbarOpen({ show: true })}>
          <MaterialIcon name="add" style={{ fontSize: "12px" }} />
        </Button>
      </div>
      <BuilderRightSideBar
        heading="Edit Action"
        isOpen={isEditbarOpen.show}
        onClose={closeEditBar}
        size="large"
        style={{ minWidth: "650px" }}
      >
        <EditActions
          actions={actions}
          setActions={handleChangeAction}
          device={device}
          tableId={tableId}
          elements={elements}
          tableType={tableType}
        />
      </BuilderRightSideBar>
    </div>
  );
};

const SummaryOfMultipleJobActions = ({ actions }) => {
  return (
    <div className="d_flex gap_2 align_center">
      {actions && actions.length > 0 ? (
        actions.map((action) => (
          <div className="border_full py_1 px_2" key={action.id}>
            {action.name}
          </div>
        ))
      ) : (
        <div>Actions buttons</div>
      )}
    </div>
  );
};

const RVOnScreenFilter = () => {
  const { blockData, blockDataDispatch } = useAppBlocksContext();
  const [allNoneSelectedColumns, setAllNoneSelectedColumns] = useState([]);
  const initialSidebarOpen = {
    show: false,
    index: null
  };
  const [isEditbarOpen, setIsEditbarOpen] = useState(initialSidebarOpen);
  const closeEditBar = () => {
    setIsEditbarOpen(initialSidebarOpen);
  };

  const handleAddFilter = (data) => {
    blockDataDispatch({ type: "ADD_ONSCREEN_FILTER", payload: data });
  };

  const handleDeleteFilter = (index) => {
    blockDataDispatch({ type: "DELETE_ONSCREEN_FILTER", payload: index });
  };

  const handleEditFilter = (index) => {
    setIsEditbarOpen({ show: true, index: index });
  };

  const handleChangeEditScreenFilter = (newFilter) => {
    blockDataDispatch({
      type: "UPDATE_SINGLE_ONSCREEN_FILTER",
      payload: { data: newFilter, index: isEditbarOpen.index }
    });
  };

  useEffect(() => {
    if (!blockData?.id || !blockData?.config?.layout.columns) return;

    let nonSelectedColumnsMap = {};
    let newOnScreenFiltersMap = {};

    const { result: mappedOfOnScreenFilter } = mapArrayToObject(blockData?.config?.layout?.onscreen_filters || []);

    blockData.config.layout.columns.forEach((column) => {
      if (column.type === "custom" && column.custom_type === "rich_column") {
        if (column.layout_config && Array.isArray(column.layout_config.layouts)) {
          const layoutData = column.layout_config.layouts;

          layoutData.forEach((columnLayoutData) => {
            const { element_config: field } = columnLayoutData;
            if (field.type === "field") {
              if (!mappedOfOnScreenFilter[field.id]) {
                if (!nonSelectedColumnsMap[field.id]) {
                  nonSelectedColumnsMap[field.id] = field;
                }
              } else {
                if (!newOnScreenFiltersMap[field.id]) {
                  newOnScreenFiltersMap[field.id] = { ...mappedOfOnScreenFilter[field.id], ...field };
                }
              }
            }
          });
        }
      }
      if (!mappedOfOnScreenFilter[column?.id]) {
        if (column.type !== "custom" && !nonSelectedColumnsMap[column.id]) {
          nonSelectedColumnsMap[column.id] = column;
        }
      } else {
        if (!newOnScreenFiltersMap[column.id]) {
          newOnScreenFiltersMap[column.id] = { ...mappedOfOnScreenFilter[column?.id], ...column };
        }
      }
    });

    blockData.config.layout.hidden_columns?.forEach((column) => {
      if (!mappedOfOnScreenFilter[column?.id]) {
        nonSelectedColumnsMap[column.id] = column;
      } else {
        if (!newOnScreenFiltersMap[column.id]) {
          newOnScreenFiltersMap[column.id] = { ...mappedOfOnScreenFilter[column?.id], ...column };
        }
      }
    });
    const nonSelectedColumnsArray = Object.values(nonSelectedColumnsMap);
    const newOnScreenFiltersArray = Object.values(newOnScreenFiltersMap);
    setAllNoneSelectedColumns(nonSelectedColumnsArray);
    blockDataDispatch({ type: "UPDATE_ONSCREEN_FILTERS", payload: newOnScreenFiltersArray });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    blockData.id,
    blockData.config.layout.columns,
    blockData.config.layout.onscreen_filters.length,
    blockData.config.layout.hidden_columns
  ]);

  return (
    <div className="gap_2 flex_wrap">
      {blockData?.config?.layout.onscreen_filters?.map((filter, index) => (
        <div key={index} className="recordview_on_screen_filter_card">
          <div className="text_wrap_nowrap d_flex justify_center">
            {filter.filter_custom_label || filter.custom_label || filter.display}
          </div>
          <div className="recordview_on_screen_filter_card_actions">
            <ButtonActionIcon type="edit" onClick={() => handleEditFilter(index)} />
            <ButtonActionIcon type="delete" onClick={() => handleDeleteFilter(index)} />
          </div>
        </div>
      ))}
      <SingleSelectBox
        options={allNoneSelectedColumns}
        labelKey={["custom_label", "display"]}
        onChange={handleAddFilter}
        placeholder="Add Filter"
        containerClassName="w_auto"
      />
      <BuilderRightSideBar isOpen={isEditbarOpen.show} onClose={closeEditBar} heading="Edit Filter">
        <EditOnScreenFilter
          filter={blockData?.config?.layout.onscreen_filters[isEditbarOpen.index]}
          onChange={handleChangeEditScreenFilter}
          allFilters={[...allNoneSelectedColumns, ...blockData.config.layout.onscreen_filters]}
        />
      </BuilderRightSideBar>
    </div>
  );
};

const EditOnScreenFilter = ({ filter, onChange, allFilters, tableId, tableType }) => {
  const handleChangeCheckbox = (e) => {
    onChange({ ...filter, [e.target.name]: e.target.checked });
  };
  const handleChangeLabel = (e) => {
    onChange({ ...filter, filter_custom_label: e.target.value });
  };
  const handleAddFilter = (selectedOption) => {
    onChange({ ...filter, intersection_field_id: selectedOption.id });
  };
  const handleAddInversion = (selectedOption) => {
    onChange({ ...filter, allow_inversion: true, inversion_field_id: selectedOption.id });
  };
  const validDataTypesArray = ["date", "datetime", "time"];
  const validDataTypes =
    validDataTypesArray.includes(filter.data_type) || validDataTypesArray.includes(filter.field_type);

  return (
    <div className="p_3 flex_column gap_4">
      <Input
        value={filter.filter_custom_label || ""}
        label="Custom Label"
        placeholder={filter.custom_label || filter.display}
        onChange={handleChangeLabel}
      />
      <Input
        type="checkbox"
        checked={filter.is_multi_select}
        name="is_multi_select"
        label="Allow Multiple Filter"
        onChange={handleChangeCheckbox}
      />
      {validDataTypes && (
        <Input
          type="checkbox"
          checked={filter.allow_intersection}
          name="allow_intersection"
          label="Allow Intersection"
          onChange={handleChangeCheckbox}
        />
      )}

      {filter.allow_intersection && (
        <>
          {allFilters ? (
            <SingleSelectBox
              selectedData={filter.intersection_field_id}
              options={allFilters}
              labelKey={["custom_label", "display"]}
              onChange={handleAddFilter}
              placeholder="Select Insertion Field"
            />
          ) : (
            <FieldSelectorFromPopup
              tableId={tableId}
              tableType={tableType}
              fieldId={filter.intersection_field_id || ""}
              onSelect={handleAddFilter}
            />
          )}
        </>
      )}

      {validDataTypes && (
        <Input
          type="checkbox"
          checked={filter.allow_inversion}
          name="allow_inversion"
          label="Allow Inversion"
          onChange={handleChangeCheckbox}
        />
      )}

      {filter.allow_inversion && (
        <>
          {allFilters ? (
            <SingleSelectBox
              selectedData={filter.inversion_field_id}
              options={allFilters}
              labelKey={["custom_label", "display"]}
              onChange={handleAddInversion}
              placeholder="Select Inversion Field"
            />
          ) : (
            <FieldSelectorFromPopup
              tableId={tableId}
              tableType={tableType}
              fieldId={filter.inversion_field_id || ""}
              onSelect={handleAddInversion}
            />
          )}
        </>
      )}
    </div>
  );
};

const EditActionPermissionsForRV = ({ selectedLayout }) => {
  const { blockData, blockDataDispatch } = useAppBlocksContext();

  const handleChangeInput = (e) => {
    blockDataDispatch({ type: "TITLE", payload: e.target.value });
  };

  const handleChangeNumberOfRows = (e) => {
    blockDataDispatch({ type: "UPDATE_NUMBER_OF_ROWS", payload: { value: e.target.value } });
  };

  const handleChangeCheckbox = (obj) => {
    blockDataDispatch({ type: "UPDATE_ACTION_PERMISSIONS", payload: obj });
  };

  return (
    <div className="d_flex justify_between px_3 align_center">
      <div>
        <Input
          name="title"
          placeholder="Title"
          value={blockData?.config?.layout?.title || ""}
          onChange={handleChangeInput}
        />
      </div>
      <RVTableToolbar
        options={{
          search: blockData?.config?.layout?.search,
          manage_column: blockData?.config?.layout?.manage_column,
          allow_download: blockData?.config?.layout?.allow_download
        }}
        onChange={(_, update) => handleChangeCheckbox(update)}
      />
      {selectedLayout === "catalog" && (
        <Input
          placeholder="Number Of Rows"
          type="number"
          value={blockData?.config?.layout?.catalog?.catalog_in_row || 1}
          onChange={handleChangeNumberOfRows}
        />
      )}
    </div>
  );
};

const RVTableToolbar = ({ options, onChange }) => {
  const handleChangeCheckbox = (name, value) => {
    onChange({ ...options, [name]: value }, { name, value });
  };

  return (
    <div className="d_flex align_center justify_between gap_3">
      <div
        className={`border_full p_2 d_flex gap_2 align_center cursor_pointer ${
          options.search ? "builder_button primary" : ""
        }`}
        onClick={() => handleChangeCheckbox("search", !options.search)}
        title="search"
      >
        <MaterialIcon name="search" className="font_size_medium" />
      </div>
      <div
        className={`border_full p_2 d_flex gap_2 align_center cursor_pointer ${
          options.manage_column ? "builder_button primary" : ""
        }`}
        onClick={() => handleChangeCheckbox("manage_column", !options.manage_column)}
        title="manage column"
      >
        <MaterialIcon name="list" className="font_size_medium" />
      </div>
      <div
        className={`border_full p_2 d_flex gap_2 align_center cursor_pointer ${
          options.allow_download ? "builder_button primary" : ""
        }`}
        onClick={() => handleChangeCheckbox("allow_download", !options.allow_download)}
        title="allow download"
      >
        <MaterialIcon name="download" className="font_size_medium" />
      </div>
    </div>
  );
};

const EditBlockTilesWithSummary = ({ tiles, handleChangeTiles, tableId, activityId, tableType }) => {
  const [isEditbarOpen, setIsEditbarOpen] = useState({
    show: false,
    index: null
  });
  const [tableObj, setTableObj] = useState({});
  const { getTableTypeData } = useTableContext();

  const folderIds = activityId ? [activityId] : [];

  const handleChangeSingletile = (newtile) => {
    const newTiles = [...tiles];
    newTiles[isEditbarOpen.index] = newtile;
    handleChangeTiles(newTiles);
  };

  const handleTileAction = (payload) => {
    const { index, action, data } = payload;
    if (action === "add") {
      const newTiles = [...tiles];
      newTiles.push({
        title: "New tile",
        id: generateObjectId(),
        aggregate_column: "",
        aggregate_config: {
          operator: "",
          group_by_column: ""
        },
        icon: "",
        aggregate_function: "",
        format_type: "",
        custom_css: "",
        custom_id: "",
        custom_classname: ""
      });
      handleChangeTiles(newTiles);
      setIsEditbarOpen({
        show: true,
        index: newTiles.length - 1
      });
    }
    if (action === "edit") {
      setIsEditbarOpen({
        show: true,
        index
      });
    }
    if (action === "delete") {
      const newTiles = [...tiles];
      newTiles.splice(index, 1);
      handleChangeTiles(newTiles);
      setIsEditbarOpen({
        show: false,
        index
      });
    }
    if (action === "sort") {
      handleChangeTiles(data);
    }
  };

  useEffect(() => {
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(tableType, tableId);
      setTableObj(tableObject);
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeEditBar = () => {
    setIsEditbarOpen({
      show: false,
      index: null
    });
  };

  return (
    <div>
      <BlockTilesSummary tiles={tiles} handleTileAction={handleTileAction} />
      <BuilderRightSideBar isOpen={isEditbarOpen.show} onClose={closeEditBar} heading="Edit Tile">
        <div style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
          <EditSingleTileOfBlock
            tile={tiles[isEditbarOpen.index]}
            handleChangeSingletile={handleChangeSingletile}
            tableId={tableId}
            tableObj={tableObj}
            folderIds={folderIds}
            tableType={tableType}
          />
        </div>
      </BuilderRightSideBar>
    </div>
  );
};
const EditBlockChartWithSummary = ({ charts, handleChangeCharts, tableId, tableType }) => {
  const [isEditbarOpen, setIsEditbarOpen] = useState({
    show: false,
    index: null
  });
  const [tableObj, setTableObj] = useState({});
  const { getTableTypeData } = useTableContext();

  // const folderIds = activityId ? [activityId] : [];

  const handleChangeSingleChart = (newChart) => {
    const newCharts = [...charts];
    newCharts[isEditbarOpen.index] = newChart;
    handleChangeCharts(newCharts);
  };

  const handleChartAction = (payload) => {
    const { index, action, data } = payload;
    if (action === "add") {
      const newCharts = [...charts];
      newCharts.push({
        id: generateObjectId(),
        type: data.dimension,
        title: "New Chart",
        sub_title: "",
        chart_type: data.type,
        data_label: "",
        data_title: "",
        xaxis_title: "",
        yaxis_title: "",
        group_columns: [],
        aggregate_column: "",
        aggregate_function: "",
        axis_inverted: false,
        add_event_config: {},
        tile_aggregate_function: "",
        chart_styles: {}
      });

      handleChangeCharts(newCharts);
      setIsEditbarOpen({
        show: true,
        index: newCharts.length - 1
      });
    }
    if (action === "edit") {
      setIsEditbarOpen({
        show: true,
        index
      });
    }
    if (action === "delete") {
      const newCharts = [...charts];
      newCharts.splice(index, 1);
      handleChangeCharts(newCharts);
      setIsEditbarOpen({
        show: false,
        index
      });
    }
    if (action === "sort") {
      handleChangeCharts(data);
    }
  };

  useEffect(() => {
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(tableType, tableId);
      setTableObj(tableObject);
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeEditBar = () => {
    setIsEditbarOpen({
      show: false,
      index: null
    });
  };

  return (
    <div className="mb_3">
      <BlockChartsSummary charts={charts} handleChartAction={handleChartAction} />
      <BuilderRightSideBar isOpen={isEditbarOpen.show} onClose={closeEditBar} heading="Edit Chart">
        <div style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
          <EditSingleChartOfBlock
            chart={charts[isEditbarOpen.index]}
            allTableColumns={tableObj}
            saveChartConfig={handleChangeSingleChart}
            tableId={tableId}
            activityId=""
            onClose={closeEditBar}
          />
        </div>
      </BuilderRightSideBar>
    </div>
  );
};

const EditSingleChartOfBlock = ({ chart, allTableColumns, saveChartConfig, tableId, activityId = "" }) => {
  const [chartConfig, setChartConfig] = useState(chart);
  const [currentTab, setCurrentTab] = useState(0);
  const { axiosInstance, handleError } = useAxiosContext();
  const [allJobs, setAllJobs] = useState([]);
  const fetchAllTemplatesAndJobs = async () => {
    try {
      const { data } = await axiosInstance.get(`/jobs/filter/?places=chart_tabular_cell`);
      setAllJobs(data);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    setChartConfig(chart);
    fetchAllTemplatesAndJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    saveChartConfig(chartConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartConfig]);
  return (
    <>
      <div className="sidebar_tab_buttons ">
        {["Label", "Data", "Style"].map((name, i) => (
          <div
            className={i === currentTab ? "active sidebar_tabs" : "sidebar_tabs"}
            key={name}
            onClick={() => setCurrentTab(i)}
          >
            {name}
          </div>
        ))}
      </div>
      <div className="charts_sidebar_outer">
        {currentTab === 0 && <EditChartLabel chartConfig={chartConfig} setChartConfig={setChartConfig} />}
        {currentTab === 1 && (
          <EditChartData
            chartConfig={chartConfig}
            setChartConfig={setChartConfig}
            allTableColumns={allTableColumns}
            tableId={tableId}
            activityId={activityId}
            allJobs={allJobs}
          />
        )}
        {currentTab === 2 && <EditChartStyles chartConfig={chartConfig} setChartConfig={setChartConfig} />}
      </div>
    </>
  );
};
const BlockTilesSummary = ({ tiles, handleTileAction }) => {
  const isMounted = useRef(false);

  const addTiles = () => {
    handleTileAction({
      action: "add",
      data: null,
      index: null
    });
  };

  const setSortableColumns = (columns) => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    const cleanItems = columns.map((item) => {
      // eslint-disable-next-line no-unused-vars
      const { chosen, selected, ...rest } = item;
      return rest;
    });
    const copyColumns = JSON.parse(JSON.stringify(cleanItems));
    handleTileAction({
      action: "sort",
      data: copyColumns
    });
  };

  if (tiles && tiles.length === 0) {
    return (
      <div
        className="d_flex align_center mx_3 p_3 gap_3"
        style={{ width: "100px", /*backgroundColor: "#F1F3F4"*/ backgroundColor: "var(--builder-active1)" }}
      >
        <div>Tiles</div>
        <Button variant="secondary" style={{ width: "22px", height: "22px" }} size="small" onClick={addTiles}>
          <MaterialIcon name="add" style={{ fontSize: "12px" }} />
        </Button>
      </div>
    );
  }
  return (
    <div className="d_flex align_center">
      <ReactSortable
        className="recordview_tile_summary_container"
        list={JSON.parse(JSON.stringify(tiles))}
        setList={setSortableColumns}
        animation={200}
      >
        {tiles.map((tile, index) => (
          <div key={tile.id} className="recordview_tile_summary_card">
            <div>{tile.title}</div>
            <div className="mt_2">--</div>
            <div className="action_button">
              <ButtonActionIcon
                type="edit"
                onClick={() => {
                  handleTileAction({
                    action: "edit",
                    data: tile,
                    index: index
                  });
                }}
              />

              <ButtonActionIcon
                type="delete"
                onClick={() => {
                  handleTileAction({
                    action: "delete",
                    data: tile,
                    index: index
                  });
                }}
              />
            </div>
          </div>
        ))}
      </ReactSortable>
      <Button variant="secondary" size="small" onClick={addTiles}>
        +
      </Button>
    </div>
  );
};
const BlockChartsSummary = ({ charts, handleChartAction }) => {
  const [isChartOpen, setIsChartOpen] = useState(false);
  const chartRef = useRef();

  useClickOutside(chartRef, () => setIsChartOpen(false));

  const addCharts = (obj) => {
    handleChartAction({
      action: "add",
      data: obj,
      index: null
    });
    setIsChartOpen(false);
  };
  const setChartType = (chartType) => {
    const type = chartType.split("/")[0];
    const dimension = chartType.split("/")[1];
    const obj = {
      type: type,
      dimension: dimension
    };
    addCharts(obj);
  };

  const setSortableColumns = (columns) => {
    const copyColumns = JSON.parse(JSON.stringify(columns));
    handleChartAction({
      action: "sort",
      data: copyColumns
    });
  };
  const allCharts = [
    "line/2d",
    "line/3d",
    "bar/2d",
    "bar/3d",
    "pie/2d",
    "table/2d",
    "table/3d",
    "spark_line/2d",
    "spark_area/2d",
    "spark_pie/2d",
    "spark_column/2d",
    "donut/2d"
  ];

  if (charts && charts.length === 0) {
    return (
      <div
        className="d_flex align_center mx_3 p_3 gap_3 "
        style={{ width: "100px", /* backgroundColor: "#F1F3F4" */ backgroundColor: "var(--builder-active1)" }}
      >
        <div>Charts</div>
        <div className="position_relative" ref={chartRef}>
          <Button
            variant="secondary"
            style={{ width: "22px", height: "22px" }}
            size="small"
            onClick={() => setIsChartOpen(!isChartOpen)}
          >
            <MaterialIcon name="add" style={{ fontSize: "12px" }} />
          </Button>
          {isChartOpen && (
            <div className="recordview_select_chart_option_popover">
              {allCharts.map((chart, i) => (
                <div key={i} onClick={() => setChartType(chart)}>
                  {chart}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="d_flex align_center">
      <ReactSortable
        className="recordview_tile_summary_container"
        list={JSON.parse(JSON.stringify(charts))}
        setList={setSortableColumns}
        animation={200}
      >
        {charts.map((chart, index) => (
          <div key={chart.id} className="recordview_tile_summary_card">
            <div>{chart.title}</div>
            <div className="mt_2">
              ({chart.chart_type}/{chart.type})
            </div>
            <div className="action_button">
              <ButtonActionIcon
                type="edit"
                onClick={() => {
                  handleChartAction({
                    action: "edit",
                    data: chart,
                    index: index
                  });
                }}
              />

              <ButtonActionIcon
                type="delete"
                onClick={() => {
                  handleChartAction({
                    action: "delete",
                    data: chart,
                    index: index
                  });
                }}
              />
            </div>
          </div>
        ))}
      </ReactSortable>
      <div className="position_relative">
        <Button variant="secondary" size="small" onClick={() => setIsChartOpen(!isChartOpen)}>
          +
        </Button>
        {isChartOpen && (
          <div className="recordview_select_chart_option_popover">
            {allCharts.map((chart, i) => (
              <div key={i} onClick={() => setChartType(chart)}>
                {chart}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const EditPreSortWithSummary = ({ defaultSort, handleChangeDefaultSort, tableId, activityId, tableType }) => {
  const [tableObj, setTableObj] = useState({});
  const { getTableTypeData } = useTableContext();

  const handleChange = (data) => {
    handleChangeDefaultSort(data);
  };

  const folderIds = activityId ? [activityId] : [];

  useEffect(() => {
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(tableType, tableId);
      setTableObj(tableObject);
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PreFilterDefaultSort
      tableObj={tableObj}
      defaultSort={defaultSort || []}
      setSortColumns={handleChange}
      tableId={tableId}
      folderIds={folderIds}
    />
  );
};

const EditPrefilterWithSummary = ({ prefiltersWithFormula, handleChange, tableId, activityId, tableType }) => {
  const [isEditPrefilterOpen, setIsEditPrefilterOpen] = useState(false);
  const { getTableTypeData } = useTableContext();
  const [tableData, setTableData] = useState({});

  const handleChangeSinglePrefilter = (data) => {
    handleChange("prefilter", data);
  };

  const handleOwnerPrefilter = (data) => {
    handleChange("owner_pre_filters", data);
  };

  const handleActionFromSummary = (action) => {
    if (action === "edit") {
      setIsEditPrefilterOpen(true);
    } else {
      console.error("Unknown action");
    }
  };

  const folderIds = activityId ? [activityId] : [];

  useEffect(() => {
    const fetchTable = async () => {
      let { data } = await getTableTypeData(tableType, tableId);
      setTableData(data);
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <PrefiltersSummaryList
        prefiltersWithFormula={prefiltersWithFormula}
        onAction={handleActionFromSummary}
        tableId={tableId}
        tableType={tableType}
      />
      <BuilderRightSideBar
        isOpen={isEditPrefilterOpen}
        onClose={() => setIsEditPrefilterOpen(false)}
        heading="Edit Prefilter"
        size="medium"
        bodyClass="rightsidebar_vertical_scroll"
      >
        <div className="p_3 flex_column gap_3">
          {(tableType === "statemachine" || tableType === "rdbms") && (
            <OwnerPreFilters
              ownerPreFilters={prefiltersWithFormula.owner_pre_filters}
              setOwnerPreFilters={handleOwnerPrefilter}
              tableData={tableData}
            />
          )}
          <NewPrefilter
            prefiltersWithFormula={{
              prefilter: prefiltersWithFormula.prefilter || [],
              prefilters_joined_by: prefiltersWithFormula.prefilters_joined_by || ""
            }}
            handleChange={handleChangeSinglePrefilter}
            tableId={tableId}
            folderIds={folderIds}
            tableType={tableType}
          />
        </div>
      </BuilderRightSideBar>
    </div>
  );
};

const PrefiltersSummaryList = ({ prefiltersWithFormula, onAction, tableType, tableId }) => {
  const { getTableTypeData } = useTableContext();
  const [tableObj, setTableObj] = useState(null);

  useEffect(() => {
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(tableType, tableId);
      setTableObj(tableObject);
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!tableObj) return null;
  if (prefiltersWithFormula.prefilter && prefiltersWithFormula.prefilter.length === 0) {
    return (
      <div className="recordview_summary_container d_flex justify_center">
        <div className="d_flex gap_3 p_3 align_center">
          <MaterialIcon name="filter_alt" />
          <span>No pre-filter is added</span>
          <Button
            variant="secondary"
            style={{ width: "24px", height: "24px" }}
            onClick={() => onAction("edit")}
            size="small"
          >
            <MaterialIcon name="add" style={{ fontSize: "12px" }} />
          </Button>
        </div>
      </div>
    );
  }
  return (
    <div className="position_relative">
      <Label className="position_absolute font_weight_semibold" style={{ top: "-8px", left: "14px" }}>
        Pre filter {prefiltersWithFormula.prefilters_joined_by || "NONE"}
      </Label>
      <div className="recordview_summary_container horizontal_scroll">
        {prefiltersWithFormula.prefilter.map((prefilter, index) => (
          <PrefilterSummaryCard key={index} prefilter={prefilter} tableObj={tableObj} />
        ))}
      </div>
      <Button
        variant="secondary"
        onClick={() => onAction("edit")}
        size="small"
        className="position_absolute font_weight_semibold"
        style={{ top: "-8px", right: "24px" }}
      >
        &#43;
      </Button>
    </div>
  );
};

const PrefilterSummaryCard = ({ prefilter, tableObj }) => {
  return (
    <div className="recordview_summary_card">
      <div>
        <span className="opacity_50">Alias</span>
        <span className="ml_1">{prefilter.alias || "NONE"}</span>
      </div>
      <div>
        <span className="opacity_50">Field</span>
        <span className="ml_1">{getFullPathOfField(prefilter.id, tableObj)}</span>
      </div>
      <div>
        <span className="opacity_50">Operator</span>
        <span className="ml_1">{getPrefilterOperatorName(prefilter.operator) || "NONE"}</span>
      </div>
      <div>
        <span className="opacity_50">Value</span>
        <span className="ml_1">{getValueDataForPrefilter(prefilter, tableObj) || "NONE"}</span>
      </div>
    </div>
  );
};

const getFullPathOfField = (fieldId, tableObj) => {
  if (!tableObj || typeof tableObj !== "object") {
    return "";
  }

  const field = tableObj[fieldId];

  if (!field) {
    return "";
  }

  const prePath = typeof field.prefix === "string" ? field.prefix : "";
  const display = typeof field.display === "string" ? field.display : "";

  return prePath ? `${prePath}.${display}` : display;
};

const getValueDataForPrefilter = (field, tableObj) => {
  const valueofField = getPrefilterOperatorValue(field.operator || "");
  switch (valueofField) {
    case "number_value":
    case "text_value":
    case "human_date":
      return field[valueofField];
    case "number_range":
    case "custom_date_range":
      return field?.[valueofField]?.[0] && field?.[valueofField]?.[1]
        ? `${field[valueofField][0]} To ${field[valueofField][1]}`
        : "Invalid Data";

    case "text_array":
      return field[valueofField]?.join(", ");
    case "logged_in_extra":
    case "logged_in_user":
    case "instance_value":
      return getFullPathOfField(field.id, tableObj);
    default:
      return JSON.stringify(field[valueofField]);
  }
};

const EditRecordviewChart = ({ chart, saveChartConfig, tableId, tableType }) => {
  const createChartTypeAndDimention = (data) => {
    saveChartConfig({ ...chart, ...data });
  };
  if (!chart.chart_type) {
    return <SelectionOfChartTypeAndDimension onCreate={createChartTypeAndDimention} />;
  }
  return (
    <EditRecordviewChartLabelAndData
      chart={chart}
      saveChartConfig={saveChartConfig}
      tableId={tableId}
      tableType={tableType}
    />
  );
};

const EditRecordviewChartLabelAndData = ({ chart, saveChartConfig, tableId, tableType }) => {
  const [tableObj, setTableObj] = useState({});
  const { getTableTypeData } = useTableContext();
  const [allJobs, setAllJobs] = useState([]);
  const { axiosInstance, handleError } = useAxiosContext();

  const fetchAllTemplatesAndJobs = async () => {
    try {
      const { data } = await axiosInstance.get(`/jobs/filter/?places=chart_tabular_cell`);
      setAllJobs(data);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(tableType, tableId);
      setTableObj(tableObject);
    };
    fetchTable();
    fetchAllTemplatesAndJobs();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tab = [
    {
      label: "Label",
      content: <EditChartLabel chartConfig={chart} setChartConfig={saveChartConfig} />
    },
    {
      label: "Data",
      content: (
        <EditChartData
          chartConfig={chart}
          setChartConfig={saveChartConfig}
          allTableColumns={tableObj}
          tableId={tableId}
          allJobs={allJobs}
        />
      )
    }
  ];
  return <BuilderTabs tabs={tab} />;
};

const chartOptions = {
  "2d": [
    { id: "line", name: "Line" },
    { id: "bar", name: "Bar" },
    { id: "pie", name: "Pie" },
    { id: "table", name: "Table" },
    { id: "spark_line", name: "Spark Line" },
    { id: "spark_area", name: "Spark Area" },
    { id: "spark_pie", name: "Spark Pie" },
    { id: "spark_column", name: "Spark Column" },
    { id: "donut", name: "Donut" }
  ],
  "3d": [
    { id: "line", name: "Line" },
    { id: "bar", name: "Bar" },
    { id: "table", name: "Table" }
  ]
};

const SelectionOfChartTypeAndDimension = ({ onCreate }) => {
  const [selectedType, setSelectedType] = useState("2d");
  const [selectedChart, setSelectedChart] = useState("line");

  const handleTypeChange = (obj) => {
    setSelectedType(obj.id);
    setSelectedChart("");
  };

  const handleChartChange = (obj) => {
    setSelectedChart(obj.id);
  };

  const handleSave = () => {
    onCreate({
      dimension: selectedType,
      chart_type: selectedChart
    });
  };
  return (
    <div className="builder_form">
      <div>
        <SingleSelectBox
          selectedData={selectedType}
          labelKey={"name"}
          valueKey={"id"}
          options={Object.keys(chartOptions).map((key) => {
            return { name: key, id: key };
          })}
          onChange={(obj) => handleTypeChange(obj)}
          label={"select type"}
        />
      </div>
      <div>
        <SingleSelectBox
          selectedData={selectedChart}
          labelKey={"name"}
          valueKey={"id"}
          options={chartOptions[selectedType]}
          onChange={(obj) => handleChartChange(obj)}
          label={"select chart"}
        />
      </div>
      <Button onClick={handleSave}>Create</Button>
    </div>
  );
};

export default NewDesktopRecordviewRenderer;

export {
  ColumnPreFiltersWithSummary,
  EditCustomColumn,
  EditOnScreenFilter,
  EditPrefilterWithSummary,
  EditPreSortWithSummary,
  EditRecordviewChart,
  EditRVColumns,
  EditSingleChartOfBlock,
  getFullPathOfField,
  MultipleJobActions,
  PrefilterSummaryCard,
  RVOnRowAction,
  RVTableToolbar,
  RVTableViewColumns,
  SummaryOfMultipleJobActions
};
